import { getCurrentUserInfo } from '@/apps/index/models/api'
import { http_withoutcookie } from '@/utils/http.ts'
import enrollMixin from '../enrollMixin.js'
import ImgCode from '@/components/enroll/ImgCode.vue'
import { getQrToken, getTokenCheck, captchaCheck, verificationCode, getMessageCode, messageLogin, rsaKeyPair } from './api.js'
import { SUBJECT_MAP } from '@/apps/assessment/model/common'
import { AssessmentAllowSubjects, ClazzAssessmentAllowSubjects } from '@/common/allow-list'
import Cookies from 'js-cookie'
import JSEncrypt from 'jsencrypt'

export default {
  name: 'LoginTpl',
  mixins: [enrollMixin],
  props: {
    showCode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tel: '',
      captcha: '',
      request_error: '',
      imgCodeSrc: '',
      act_key: '1',
      remember_me: false,
      loading: false,
      captcha_token: '',
      uid: '',
      tiuid: '',
      qrCode: '',
      successText: '',
      errorText: '',
      activeKey: '1',
      // 验证码文字
      realMsg: '发送验证码',
      // 验证码按钮可点击
      disabled: false,
      // 验证码等待时间
      wait: 60,
      // 短信验证码
      telCode: '',
      // 定时器id
      timeback: null
    }
  },
  methods: {
    // 获取手机验证码
    async codeBtnClick() {
      setTimeout(() => {
        // 发送验证码点击埋点
        window['sensors'].track('SendMessage_buttonClick', {
          buttonName: this.msg,
          position: this.$route.meta.title || '未知'
        })
      }, 200)
      // 验证手机号
      if (!/^1\d{10}$/.test(this.tel.trim())) {
        this.tel_error = '请输入11位手机号码'
        return
      }
      // 需要校验图形验证码
      if (!(await this.imgCodeValid())) {
        this.tel_error = ''
        this.code_error = '请输入正确的图形验证码'
        return
      }
      this.tel_error = ''
      this.code_error = ''
      // 校验通过后发送短信
      try {
        let res = await getMessageCode({
          phone: this.tel.trim()
        })
        // 发送失败
        if (!res.success) {
          this.$message.error(res.error)
          // 需要更新图形验证码
          this.getNewImageCode()
          return
        }
        // 发送成功，发送通知
        this.$emit('success')
        this.$message.success('短信发送成功')
        this.time()
      } catch (err) {
        // 需要更新图形验证码
        this.getNewImageCode()
      }
    },
    time() {
      if (this.wait === 1) {
        this.wait = 60
        this.disabled = false
        this.realMsg = '发送验证码'
      } else {
        if (!this.clean) {
          clearTimeout(this.timeback)
        } else {
          this.wait--
          this.disabled = true
          this.realMsg = this.wait + 'S'
          this.timeback = setTimeout(() => this.time(), 1000)
        }
      }
    },
    getNewCode() {
      this.getNewImageCode()
      window['sensors'].track('Loginpop_buttonClick', { buttonName: '验证码' })
    },
    getNewImageCode() {
      try {
        this.captcha_token = String(new Date().getTime()) + Math.random()
        this.imgCodeSrc = location.origin + '/api/auth/captcha?captcha_token=' + this.captcha_token
      } catch (e) {
        this.captcha_token = String(new Date().getTime()) + Math.random()
        this.imgCodeSrc = location.origin + '/api/auth/captcha?captcha_token=' + this.captcha_token
      }
    },
    removeSpace(e) {
      e.target.value = e.target.value.replace(/\s+/g, '')
    },
    callback(key) {
      this.act_key = key
      if (key == '1') {
        this.code = ''
      } else {
        this.psw = ''
      }
    },
    async enroll() {
      let skey = ''
      let password = this.psw
      let phone = this.tel.trim()
      // 加密
      try {
        const { data, success } = await rsaKeyPair({})
        if (success) {
          const { key, public_key } = data
          skey = key
          // 对密码进行加密
          // 对手机号/账号进行加密
          let encryptor = new JSEncrypt()
          encryptor.setPublicKey(public_key)
          try {
            password = encryptor.encrypt(password)
            phone = encryptor.encrypt(phone)
          } catch (e) {
            console.log(e)
          }
        } else {

        }
      } catch(e) {

      }
      // 短信登录或密码登录
      let postd = this.telCode ? {
        phone,
        message_code: this.telCode,
        captcha: this.captcha && this.captcha.trim(),
        captcha_token: this.captcha_token,
        encrypted: 'phone',
        encryption_key: skey
      } : {
        username: phone,
        password,
        remember_me: this.remember_me,
        captcha: this.captcha && this.captcha.trim(),
        captcha_token: this.captcha_token,
        encrypted: 'password,username', // 如果是多个，使用逗号拼接
        encryption_key: skey
      }
      window['sensors'].track('Loginpop_buttonClick', { buttonName: '登录按钮' })
      this.loading = true
      if (this.$store.state.need_captcha) {
        postd.captcha = this.captcha && this.captcha.trim()
      }
      let rdata = this.telCode ? await messageLogin(postd)
        : await http_withoutcookie('/api/auth/login', postd)
      // 短信登录
      this.loading = false
      if (rdata.success) {
        // 记住userName 和 password
        this.$store.commit('SET_PLATFORMLOGIN', {})
        const { uid, tiuid } = Cookies.get()
        // Cookies.set('tiuid', uid, { expires: 30 })
        if (this.remember_me) {
          this._set(this.tel, this.psw, 30)
        } else {
          this._clear()
        }
        this._get()
        window['sensors'].login(this.uid)
        window['sensors'].track('TIKU_login_success', { login_type: '点击登录' })
        // 获取个人信息
        let d = await getCurrentUserInfo()
        if (d.success) {
          let groupLeaderSubject = []
          this.$store.commit('SET_USER_INFO', d.data)
          // 获取默认学科
          let subject = d.data.subjects.map((item) => {
            const nick = SUBJECT_MAP[item[0]]
            return {
              label: item[1],
              value: item[0],
              nick
            }
          })
          groupLeaderSubject = d.data.subjectLeaders || []
          // result 是该教师所有学科中的学科组长学科
          let result = []
          groupLeaderSubject.forEach((item) => {
            for (let n of subject) {
              if (item && item.subject === n.nick) {
                n.clazzLevels = item.clazzLevels
                result = [...result, n]
              }
            }
          })
          // 获取学科组长学科，并进行过滤
          let final = []
          AssessmentAllowSubjects.forEach((item) => {
            for (let n of result) {
              if (item && item.value === n.value) {
                final = [...final, n]
              }
            }
          })
          let final2 = []
          ClazzAssessmentAllowSubjects.forEach((item) => {
            for (let n of subject) {
              if (item && item.value === n.value) {
                final = [...final, n]
              }
            }
          })
          this.$store.commit('SET_SUPPORT_SUBJECTS', final)
          this.$store.commit('SET_CLAZZ_SUPPORT_SUBJECTS', final2)
          if (this.isSchoolAssessment && final && final.length > 0) {
            this.$store.commit('SET_SUBJECT', final[0])
          } else if (subject && subject.length > 0) {
            this.$store.commit('SET_SUBJECT', subject[0])
          } else {
            this.$store.commit('SET_SUBJECT', {
              label: '小学语文',
              value: 101,
              nick: 'CHINESE'
            })
          }
        }
        // store
        if (typeof d.data != 'undefined') {
          this.$emit('on_cancel')
          // this.$store.commit('SET_USER_VERIFY', true)
          // 调整emit时机
          this.$emit('login_success', true)
        }
        // 记住我
      } else {
        // 只要登录失败就刷新验证码
        this.captcha = ''
        this.getNewImageCode()
        this.showError(rdata)
        this.telCode && this.$message.error(rdata.error)
      }
    },
    _set(name, pwd, num) {
      Cookies.set('tiUserName', window.btoa(name), { expires: num })
      Cookies.set('tiUserPwd', window.btoa(pwd), { expires: num })
    },
    _get() {
      const { tiUserName, tiUserPwd, uid } = Cookies.get()
      this.tel = tiUserName ? window.atob(tiUserName) : ''
      this.pwd = tiUserPwd ? window.atob(tiUserPwd) : ''
      this.uid = uid
    },
    _clear() {
      Cookies.remove('tiUserName')
      Cookies.remove('tiUserPwd')
    },
    async getToken() {
      try {
        let { data, success } = await getQrToken({})
        if (success) {
          this.qrCode = '/api/auth/qr/code?qr_token=' + data.qr_token
          setTimeout(() => {
            this.checkToken(data.qr_token)
          }, 1000)
        } else {
          this.qrCode = ''
        }
      } catch (e) {
        this.qrCode = ''
      }
    },
    async checkToken(token) {
      try {
        let data = await getTokenCheck({
          qr_token: token,
          delete_after_verify: true
        })
        if (data.success) {
          // console.log(data.success)
          this.$store.commit('SET_PLATFORMLOGIN', {})
          this.successText = '扫码成功'
          this.errorText = ''
          // 登录成功之后
          this.$nextTick(async () => {
            this._get()
            window['sensors'].login(this.uid)
            window['sensors'].track('TIKU_login_success', { login_type: '扫码登录' })
            // 获取个人信息
            let d = await getCurrentUserInfo()
            this.$store.commit('SET_USER_INFO', d.data)
            let subject = d.data.subjects.map((item) => {
              return {
                label: item[1],
                value: item[0]
              }
            })
            // this.$store.commit('SET_SUBJECT', subject[0])
            if (subject && subject.length > 0) {
              this.$store.commit('SET_SUBJECT', subject[0])
            } else {
              this.$store.commit('SET_SUBJECT', {
                label: '小学语文',
                value: 101
              })
            }
            // store
            if (typeof d.data != 'undefined') {
              this.$emit('on_cancel')
              // this.$store.commit('SET_USER_VERIFY', true)
              // 调整emit时机
              this.$emit('login_success', true)
            }
          })
        } else {
          this.successText = ''
          if (data.error_type === 'NOT_SCANNED') {
            this.errorText = ''
            if (window.checkToken) {
              clearTimeout(window.checkToken)
            }
            window.checkToken = setTimeout(() => {
              this.checkToken(token)
            }, 1000)
          } else if (data.error_type === 'OUT_DATED') {
            this.errorText = '二维码已失效'
          } else {
            this.errorText = data.error
          }
        }
      } catch (e) {
        this.successText = ''
        this.errorText = ''
        console.log(e)
      }
    },
    onTabChange(activeKey) {
      if (Number(activeKey) === 2) {
        window['sensors'].track('Loginpop_buttonClick', { buttonName: '短信登录tab' })
      } else {
        window['sensors'].track('Loginpop_buttonClick', { buttonName: '密码登录tab' })
      }
      this.resetInput()
    },
    // 清空输入框
    resetInput() {
      this.tel = ''
      this.psw = ''
      this.captcha = ''
      this.telCode = ''
      this.tel_error = ''
      this.password_error = ''
      this.code_error = ''
      this.telCodeError = ''
      this.getNewImageCode()
    },
    reset() {
      this.getToken()
    },
    // 忘记密码
    goForget() {
      // 重置输入框
      this.clearEnroll()
      this.$emit('toChangeTab', 3)
      window['sensors'].track('Loginpop_buttonClick', { buttonName: '忘记密码' })
    },
    // 点击注册按钮
    onRegisterClick(e) {
      window['sensors'].track('Loginpop_buttonClick', { buttonName: '注册按钮' })
      setTimeout(() => {
        window.open('/register')
      }, 200)
      e.preventDefault()
    },
    // 点击扫码使用帮助
    onHelpClick(e) {
      window['sensors'].track('Loginpop_buttonClick', { buttonName: '扫码使用帮助' })
      setTimeout(() => {
        window.open('http://help.17zuoye.com/?p=1543')
      }, 200)
      e.preventDefault()
    },
    // 点击下载手机客户端
    onTerminalClick(e) {
      window['sensors'].track('Loginpop_buttonClick', { buttonName: '下载手机客户端' })
      setTimeout(() => {
        window.open('https://www.17zuoye.com/help/downloadApp.vpage?refrerer=pc')
      }, 200)
      e.preventDefault()
    },
    // 校验图形验证码
    async imgCodeValid() {
      if (!this.captcha) return false
      try {
        const res = await captchaCheck({
          // 图形验证码
          captcha: this.captcha,
          // 前端随机签名
          captcha_token: this.captcha_token
        })
        // 验证失败重新刷新验证码
        !res.success && this.getNewImageCode()
        return res.success
      } catch (err) {
        return false
      }
    },
    // 加密
    async encrypt() {
      try {
        const { data, success } = await rsaKeyPair({})
        if (success) {
          const { key, public_key } = data
          // 对密码进行加密

        }
      } catch(e) {

      }
    }
  },
  computed: {
    validBind: function() {
      return (
        (this.act_key == 2 && this.tel !== '' && this.code != '') ||
        (this.act_key == 1 && this.tel !== '' && this.psw != '')
      )
    },
    // 短信验证码
    messageValidBind: function() {
      return this.tel !== '' && this.captcha != ''&& this.telCode != ''
    },
    position() {
      return location.pathname + location.search || ''
    },
    getLoginModal() {
      return this.$store.state.loginModal
    },
    isSchoolAssessment() {
      return this.$route && this.$route.meta && this.$route.meta.section === '校级测评'
    }
  },
  components: { ImgCode },
  watch: {
    tel: function(val) {
      if (val) {
      }
    },
    clean: function(val) {
      if (!val) {
        this.clearLogin()
        clearTimeout(window.checkToken)
      }
      if (val) {
        this.captcha = ''
        this.getNewImageCode()
        this.activeKey = '1'
      }
    },
    showCode: function(val) {
      val && this.getToken()
      // 清空输入项
      this.resetInput()
    }
  },
  mounted() {
    this.getNewImageCode()
    // 如果记住账号密码，显示
    this._get()
  }
}
